import type { RequestConfig } from '@customTypes/index';
import type { WorkItemDto, WorkItemStatus } from '@customTypes/types';
import qs from 'qs';

import { api } from '@/shared/api/instance';

export type ClubWorkItemsListRequest = {
  profileId: string;
  status?: WorkItemStatus[];
};

export type ClubWorkItemsListParams = RequestConfig<ClubWorkItemsListRequest>;

export const clubWorkItemsList = async ({
  params,
  config
}: ClubWorkItemsListParams) =>
  api.get<WorkItemDto[]>(`/api/work/items/club/${params.profileId}`, {
    ...config,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: 'repeat' }),
    params: {
      status: params.status
    }
  });
